import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Paper, Typography, Box, Grid, FormControl, InputLabel, MenuItem, FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import Select from "react-select";
import Swal from "sweetalert2";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import generateAdmissionForm from "../pages/generateAdmissionForm";
import { useForm, Controller } from "react-hook-form";
import api from "../api";

const AddStudent = () => {

  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const { control, formState: { errors } } = useForm();

  const [student, setStudent] = useState({
    name: "",
    dob: "",
    aadhaar_no: "",
    blood_group: "",
    gender: "",
    category: "",
    fatherName: "",
    f_aadhaar_no: "",
    motherName: "",
    m_aadhaar_no: "",
    mobile: "",
    email: "",
    state: "",
    district: "",
    block: "",
    locality: "",
    village: "",
    post_office: "",
    police_station: "",
    pincode: "",
    classes: "",
    sections: "",
    stream: "",
    roll_no: "",
    bpl_no: "",
    admission_fees: "",
    banks: "",
    account_no: "",
    ifsc_code: "",
    file: "",
    transportLocations: "",
    fees: []


  });



  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [banks, setBanks] = useState([]);
  // Image Crop State
  const [srcImage, setSrcImage] = useState(null);
  const [crop, setCrop] = useState({ aspect: 1, width: 100 });
  const [croppedImage, setCroppedImage] = useState(null);
  const imageRef = useRef(null);

  // class & sec
  const [classes, setClass] = useState([]);
  const [sections, setSections] = useState([]);
  const [stream, setStream] = useState([]);
  const [fees, setFees] = useState([]);
  const [transportLocations, setTransportLocations] = useState([]);
  const [defaultCheckedFees, setDefaultCheckedFees] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = {
      id: localStorage.getItem("id"),
      user_id: localStorage.getItem("user_id"),
      name: localStorage.getItem("name"),
      mobile: localStorage.getItem("mobile"),
    };

    if (!token) {
      navigate("/login");
    } else {
      setUser(storedUser);
    }
  }, []);

  useEffect(() => {
    fetch("https://dgps.co.in/api/get-states")
      .then(res => res.json())
      .then(data => setStates(data.data))
      .catch(error => console.error("Error fetching states:", error));
  }, []);

  useEffect(() => {
    if (student.state) {
      fetch(`https://dgps.co.in/api/get-cities/${student.state}`)
        .then(res => res.json())
        .then(data => setDistricts(data.data))
        .catch(error => console.error("Error fetching districts:", error));
    } else {
      setDistricts([]);
    }
  }, [student.state]);

  useEffect(() => {
    if (student.district) {
      fetch(`https://dgps.co.in/api/get-blocks/${student.district}`)
        .then(res => res.json())
        .then(data => setBlocks(data.data))
        .catch(error => console.error("Error fetching blocks:", error));
    } else {
      setBlocks([]);
    }
  }, [student.district]);

  useEffect(() => {
    fetch("https://dgps.co.in/api/get-bank")
      .then(res => res.json())
      .then(data => setBanks(data.data))
      .catch(error => console.error("Error fetching banks:", error));
  }, []);

  // get class & sections
  useEffect(() => {
    fetch("https://dgps.co.in/api/get-classes")
      .then(res => res.json())
      .then(data => setClass(data.data))
      .catch(error => console.error("Error fetching class:", error));
  }, []);

  useEffect(() => {
    if (student.classes) {
      fetch(`https://dgps.co.in/api/get-sections/${student.classes}`)
        .then(res => res.json())
        .then(data => setSections(data.data))
        .catch(error => console.error("Error fetching section:", error));
    } else {
      setSections([]);
    }
  }, [student.classes]);

  useEffect(() => {
    if (student.classes) {
      fetch(`https://dgps.co.in/api/get-fees/${student.classes}`)
        .then(res => res.json())
        .then(data => {
          setFees(data.data);
          setDefaultCheckedFees(data.default_fees); // ✅ Default fees set করা
        })
        .catch(error => console.error("Error fetching fees:", error));
    } else {
      setFees([]);
      setDefaultCheckedFees([]);
    }
  }, [student.classes]);


  useEffect(() => {
    fetch("https://dgps.co.in/api/get-stream")
      .then(res => res.json())
      .then(data => setStream(data.data))
      .catch(error => console.error("Error fetching stream:", error));
  }, []);


  // Get Admission & Re-Admission Fee IDs
  const admissionFeeId = fees.find(fee => fee.fee_type.toLowerCase() === "admission")?.id;
  const reAdmissionFeeId = fees.find(fee => fee.fee_type.toLowerCase() === "re admission")?.id;

  const handleFeeChange = (feeId) => {
    const selectedFee = fees.find(f => f.id === feeId);
    const isTransport = selectedFee && selectedFee.fee_type.toLowerCase() === 'transport';

    setStudent((prevStudent) => {
      // Prevent Admission & Re-Admission from being selected together
      if (feeId === admissionFeeId) {
        return { ...prevStudent, fees: [admissionFeeId] };
      }
      if (feeId === reAdmissionFeeId) {
        return { ...prevStudent, fees: [reAdmissionFeeId] };
      }

      const newFees = prevStudent.fees.includes(feeId)
        ? prevStudent.fees.filter(id => id !== feeId)
        : [...prevStudent.fees, feeId];

      return { ...prevStudent, fees: newFees };
    });

    if (isTransport && !student.fees.includes(feeId)) {
      fetch("https://dgps.co.in/api/get-tr-location")
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setTransportLocations(data.data);
          }
        })
        .catch(err => console.error("Transport fetch error:", err));
    } else if (isTransport && student.fees.includes(feeId)) {
      setTransportLocations([]);
      setStudent(prev => ({ ...prev, transportLocations: "" }));
    }
  };


  // Function to handle "All Select"
  const handleAllSelect = (event) => {
    if (event.target.checked) {
      // Select all except Admission & Re-Admission
      setStudent((prevStudent) => ({
        ...prevStudent,
        fees: fees
          .filter(fee => fee.id !== admissionFeeId && fee.id !== reAdmissionFeeId)
          .map(fee => fee.id)
      }));
    } else {
      // Unselect all
      setStudent((prevStudent) => ({ ...prevStudent, fees: [] }));
    }
  };


  // Check if all checkboxes (except Admission & Re-Admission) are selected
  const isAllSelected = fees
    .filter(fee => fee.id !== admissionFeeId && fee.id !== reAdmissionFeeId)
    .every(fee => student.fees.includes(fee.id));


  const handleChange = (e) => {
    let { name, value } = e.target;

    // Email should always be lowercase
    if (name === "email") {
      setStudent((prev) => ({
        ...prev,
        [name]: value.toLowerCase(),
      }));
      return;
    }

    // Numeric fields (Only digits allowed)
    const numericFields = ["aadhaar_no", "f_aadhaar_no", "m_aadhaar_no", "mobile", "pincode", "account_no", "roll_no", "admission_fees"];
    if (numericFields.includes(name)) {
      value = value.replace(/\D/g, ""); // Remove non-digit characters

      // Aadhaar Formatting (XXXX XXXX XXXX)
      if (["aadhaar_no", "f_aadhaar_no", "m_aadhaar_no"].includes(name)) {
        if (value.length > 12) value = value.slice(0, 12);
        let formattedValue = value.replace(/(\d{4})/g, "$1 ").trim();

        setStudent((prev) => ({
          ...prev,
          [name]: value, // Unformatted value for database
          [`${name}_formatted`]: formattedValue, // Formatted value for UI
        }));
        return;
      }

      // Mobile Formatting (XXXX XXX XXX)
      if (name === "mobile") {
        if (value.length > 10) value = value.slice(0, 10);
        let formattedValue = value.replace(/(\d{4})(\d{3})(\d{0,3})/, "$1 $2 $3").trim();

        setStudent((prev) => ({
          ...prev,
          [name]: value, // Unformatted value for database
          [`${name}_formatted`]: formattedValue, // Formatted value for UI
        }));
        return;
      }

      // Pincode (Max 6 digits)
      if (name === "pincode" && value.length > 6) {
        value = value.slice(0, 6);
      }

      setStudent((prev) => ({ ...prev, [name]: value }));
      return;
    }

    // Text Fields (No digits allowed, auto-uppercase)
    const textFields = ["name", "fatherName", "motherName", "state", "district", "block", "locality", "village", "post_office", "police_station"];
    if (textFields.includes(name)) {
      value = value.replace(/[^A-Za-z\s]/g, ""); // Remove all digits & special characters
      value = value.toUpperCase(); // Convert to uppercase
    }

    setStudent((prev) => ({
      ...prev,
      [name]: value,
    }));
  };




  // Handle File Input
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setStudent((prev) => ({ ...prev, file }));
      const reader = new FileReader();
      reader.onload = (e) => {
        setSrcImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Crop the Image
  const getCroppedImage = useCallback(() => {
    if (imageRef.current && crop.width && crop.height) {
      const canvas = document.createElement("canvas");
      const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
      const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
      canvas.width = crop.width * scaleX;
      canvas.height = crop.height * scaleY;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(
        imageRef.current,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width * scaleX,
        crop.height * scaleY
      );

      const base64Image = canvas.toDataURL("image/jpeg");
      setCroppedImage(base64Image);
      setSrcImage(null); // Hide the original image after cropping
    }
  }, [crop]);

  // Custom Styles for React-Select to Match Input Field
  const selectStyles = {
    control: (provided) => ({
      ...provided,
      height: 56, // Same as MUI TextField
      minHeight: 56,
      backgroundColor: "#ffffff", // White background
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff", // Dropdown menu background white
      zIndex: 1000,
    }),
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     let imagePath = "";

  //     // Check if a file is selected
  //     if (student.file) {
  //       let formData = new FormData();
  //       formData.append("file", student.file);

  //       let imageResponse = await fetch("https://dgps.co.in/api/upload-student-image", {
  //         method: "POST",
  //         body: formData,
  //       });

  //       let imageData = await imageResponse.json();
  //       console.log("Image Upload Response:", imageData); // Debugging

  //       if (!imageData.success) {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Image Upload Failed",
  //           text: imageData.message || "Error uploading image!",
  //         });
  //         return; // Stop further processing if image upload fails
  //       }

  //       imagePath = imageData.file_path;
  //     }

  //     // ✅ Step 2: Filter out transport-type fees before submission
  //     const filteredFees = student.fees
  //     .map(feeId => {
  //       const feeObj = fees.find(f => f.id === feeId);
  //       if (feeObj && feeObj.fee_type.toLowerCase() !== "transport") {
  //         return {
  //           id: feeObj.id,
  //           amount: feeObj.amount
  //         };
  //       }
  //       return null;
  //     })
  //     .filter(fee => fee !== null); // Remove nulls (transport or unmatched)


  //     const created_by = user?.id;
  //     // Submit student data with the uploaded image path
  //     let response = await fetch("https://dgps.co.in/api/add-student", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ ...student, created_by:created_by, fees: filteredFees, file: imagePath }),
  //     });

  //     let data = await response.json();
  //     console.log("Student Data Response:", data); // Debugging

  //     if (!data.success) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Failed to Add Student",
  //         text: data.message || "Unknown error occurred.",
  //       });
  //       return; // Prevents further execution
  //     }

  //     await generateAdmissionForm({ ...student, file: imagePath })
  //       .then(() => {
  //         Swal.fire({
  //           icon: "success",
  //           title: "Student Added Successfully!",
  //           timer: 2000,
  //           showConfirmButton: true,
  //         }).then(() => {
  //           console.log("Redirecting to Admin Dashboard...");
  //           navigate("/admin/dashboard"); // Redirect after confirmation
  //         });
  //       })
  //       .catch((pdfError) => {
  //         console.error("PDF Generation Failed:", pdfError);
  //         Swal.fire({
  //           icon: "error",
  //           title: "PDF Generation Failed",
  //           text: pdfError.message,
  //         });
  //       });

  //   } catch (error) {
  //     console.error("Error:", error);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Unexpected Error",
  //       text: error.message || "Something went wrong.",
  //     });
  //   }
  // };

  // অনুমান: তোমার ফাইলে `api` (axios instance) এবং `generateAdmissionForm`, `Swal`, `navigate` ইত্যাদি already imported/available

  const handleSubmit = async (e) => {
    e.preventDefault();

    // guard: token & school_id
    const token = localStorage.getItem("token");
    if (!token) {
      console.warn("AddStudent: token missing, redirecting to login");
      navigate("/login");
      return;
    }
    const school_id = localStorage.getItem("school_id");
    if (!school_id) {
      console.warn("AddStudent: school_id missing, redirecting to login");
      navigate("/login");
      return;
    }

    try {
      let imagePath = "";

      // 1) upload image if present (use api to let interceptor add auth header)
      if (student.file) {
        try {
          const formData = new FormData();
          formData.append("file", student.file);
          // If backend needs school_id with upload, include it
          //formData.append("school_id", school_id);

          const imgRes = await api.post("/upload-student-image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          const imgData = imgRes?.data || {};
          console.log("Image Upload Response:", imgData);

          if (!imgData.success && imgData.success !== true) {
            // Show error returned by server
            Swal.fire({
              icon: "error",
              title: "Image Upload Failed",
              text: imgData.message || "Error uploading image!",
              confirmButtonColor: "#d33",
            });
            return;
          }

          // adapt to shape (some APIs return file_path, some path)
          imagePath = imgData.file_path || imgData.data?.file_path || imgData.path || "";
        } catch (imgErr) {
          console.error("Image upload error:", imgErr?.response || imgErr);
          const msg = imgErr?.response?.data?.message || imgErr?.message || "Image upload request failed";
          Swal.fire({
            icon: "error",
            title: "Image Upload Error",
            text: msg,
            confirmButtonColor: "#d33",
          });
          return;
        }
      }

      // 2) Filter fees: remove transport-type & map to {id, amount}
      const filteredFees = (Array.isArray(student.fees) ? student.fees : [])
        .map((feeId) => {
          const feeObj = fees.find((f) => String(f.id) === String(feeId));
          if (feeObj && String((feeObj.fee_type || "").toLowerCase()) !== "transport") {
            return { id: feeObj.id, amount: feeObj.amount };
          }
          return null;
        })
        .filter((f) => f !== null);

      // 3) prepare payload
      const created_by = localStorage.getItem("id") || null;
      const payload = {
        ...student,
        created_by,
        school_id,
        fees: filteredFees,
        file: imagePath, // backend expects file path
      };

      // If student.file existed, you already uploaded; remove raw file object from payload
      if (payload.file && payload.file instanceof File === false) {
        // good: file contains path string
      } else {
        // ensure we don't accidentally send the raw File in JSON
        delete payload.file;
      }

      // 4) send add-student request via api (axios)
      let addRes;
      try {
        addRes = await api.post("/add-student", payload);
      } catch (postErr) {
        console.error("Add student request failed:", postErr?.response || postErr);
        const serverMsg = postErr?.response?.data?.message || postErr?.message || "Request failed";
        Swal.fire({
          icon: "error",
          title: "Failed to Add Student",
          text: serverMsg,
          confirmButtonColor: "#d33",
        });
        return;
      }

      const addData = addRes?.data || {};
      console.log("Student Data Response:", addData);

      if (!addData.success && addData.success !== true) {
        Swal.fire({
          icon: "error",
          title: "Failed to Add Student",
          text: addData.message || "Unknown error occurred.",
          confirmButtonColor: "#d33",
        });
        return;
      }

      // 5) generate admission form PDF (optional) and navigate on success
      try {
        await generateAdmissionForm({ ...student, file: imagePath, school_id });
        await Swal.fire({
          icon: "success",
          title: "Student Added Successfully!",
          timer: 1600,
          showConfirmButton: true,
        });
        console.log("Redirecting to Admin Dashboard...");
        navigate("/admin/dashboard");
      } catch (pdfErr) {
        console.error("PDF Generation Failed:", pdfErr);
        Swal.fire({
          icon: "error",
          title: "PDF Generation Failed",
          text: pdfErr?.message || "Failed to generate admission form PDF.",
          confirmButtonColor: "#d33",
        });
        // Still optionally redirect (comment/uncomment as you prefer)
        // navigate("/admin/dashboard");
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
      Swal.fire({
        icon: "error",
        title: "Unexpected Error",
        text: error?.message || "Something went wrong.",
        confirmButtonColor: "#d33",
      });
    }
  };



  return (

      <Box sx={{ maxWidth: 700, margin: "0px auto", p: 0 }}>
        <Paper sx={{ padding: 4, boxShadow: 3, borderRadius: 3 }}>
          <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: "bold", color: "#1976D2", mb: 3 }}>
            Student Information Form
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}><TextField fullWidth label="Name" name="name" value={student.name} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} required /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth type="date" name="dob" onChange={handleChange} required /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="Student Aadhaar No" name="aadhaar_no" value={student.aadhaar_no_formatted || ""} onChange={handleChange} /></Grid>

              <Grid item xs={12} sm={6}>
                <Select
                  styles={selectStyles}
                  options={[
                    { label: "Select Blood Group", value: "" },
                    { label: "A+", value: "A+" },
                    { label: "A-", value: "A-" },
                    { label: "B+", value: "B+" },
                    { label: "B-", value: "B-" },
                    { label: "AB+", value: "AB+" },
                    { label: "AB-", value: "AB-" },
                    { label: "O+", value: "O+" },
                    { label: "O-", value: "O-" }
                  ]}
                  onChange={selected => setStudent({ ...student, blood_group: selected?.value || "" })}
                  placeholder="Select Blood Group "
                  isClearable
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Select
                  styles={selectStyles}
                  options={[
                    { label: "Select Gender", value: "" },
                    { label: "Male", value: "Male" },
                    { label: "Female", value: "Female" }
                  ]}
                  onChange={selected => setStudent({ ...student, gender: selected?.value || "" })}
                  placeholder="Select Gender"
                  isClearable
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Select
                  styles={selectStyles}
                  options={[
                    { label: "Select Social Category", value: "" },
                    { label: "General", value: "General" },
                    { label: "OBC", value: "OBC" },
                    { label: "SC", value: "SC" },
                    { label: "ST", value: "ST" }
                  ]}
                  onChange={selected => setStudent({ ...student, category: selected?.value || "" })}
                  placeholder="Select Social Category"
                  isClearable
                />
              </Grid>

              <Grid item xs={12} sm={6}><TextField fullWidth label="Father's Name" name="fatherName" value={student.fatherName} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} required /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="Father Aadhaar No" name="f_aadhaar_no" value={student.f_aadhaar_no_formatted || ""} onChange={handleChange} /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="Mother's Name" name="motherName" value={student.motherName} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} required /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="Mother Aadhaar No" name="m_aadhaar_no" value={student.m_aadhaar_no_formatted || ""} onChange={handleChange} /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="Mobile" name="mobile" value={student.mobile_formatted || ""} onChange={handleChange} required /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="Email" name="email" onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toLowerCase()} /></Grid>

              <Grid item xs={12}>

                <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1976D2", mb: 2, }}>
                  Address
                </Typography>

              </Grid>
              <Grid item xs={12} sm={6}>
                <Select
                  styles={selectStyles}
                  options={[{ id: "", name: "Select State" }, ...states]}
                  getOptionLabel={e => e.name}
                  getOptionValue={e => e.id}
                  onChange={selected => setStudent({ ...student, state: selected?.id || "" })}
                  placeholder="Select State"
                  isClearable
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Select
                  styles={selectStyles}
                  options={[{ id: "", name: "Select District" }, ...districts]}
                  getOptionLabel={e => e.name}
                  getOptionValue={e => e.id}
                  onChange={selected => setStudent({ ...student, district: selected?.id || "" })}
                  isDisabled={!student.state}
                  placeholder="Select District"
                  isClearable
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Select
                  styles={selectStyles}
                  options={[{ id: "", name: "Select Block" }, ...blocks]}
                  getOptionLabel={e => e.name}
                  getOptionValue={e => e.id}
                  onChange={selected => setStudent({ ...student, block: selected?.id || "" })}
                  isDisabled={!student.district}
                  placeholder="Select Block"
                  isClearable
                />
              </Grid>


              <Grid item xs={12} sm={6}><TextField fullWidth label="Locality" name="locality" value={student.locality} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="Village" name="village" value={student.village} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="Post Office" name="post_office" value={student.post_office} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="Police Station" name="police_station" value={student.police_station} onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="Pin Code" name="pincode" value={student.pincode || ""} onChange={handleChange} /></Grid>

              <Grid item xs={12}>

                <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1976D2", mb: 2 }}>
                  School Details
                </Typography>

              </Grid>

              <Grid item xs={12} sm={6}>


                <Select
                  styles={selectStyles}
                  options={[{ id: "", class_name: "Select Class" }, ...classes]}
                  getOptionLabel={e => e.class_name}
                  getOptionValue={e => e.id}
                  onChange={selected => setStudent({ ...student, classes: selected?.id || "" })}
                  placeholder="Select Class *"
                  isClearable
                />
              </Grid>


              <Grid item xs={12} sm={6}>
                <Select
                  styles={selectStyles}
                  options={[{ id: "", section_name: "Select Sections" }, ...sections]}
                  getOptionLabel={e => e.section_name}
                  getOptionValue={e => e.id}
                  onChange={selected => setStudent({ ...student, sections: selected?.id || "" })}
                  isDisabled={!student.classes}
                  placeholder="Select Sections *"
                  isClearable
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Select
                  styles={selectStyles}
                  options={[{ id: "", stream_name: "Select Stream" }, ...stream]}
                  getOptionLabel={e => e.stream_name}
                  getOptionValue={e => e.id}
                  onChange={selected => setStudent({ ...student, stream: selected?.id || "" })}
                  placeholder="Select Stream *"
                  //value={stream.find(e => e.id === student.stream) || stream.find(e => e.stream_name === "General") || null} 
                  //value={stream.find(e => e.id === student.stream)?.id || stream.find(e => e.stream_name === "General")?.id || ""}

                  isClearable
                />
              </Grid>



              <Grid item xs={12} sm={6}><TextField fullWidth label="Roll Number" name="roll_no" value={student.roll_no || ""} onChange={handleChange} required /></Grid>
              <Grid item xs={12} sm={12}><TextField fullWidth label="BPL Number" name="bpl_no" onChange={handleChange} /></Grid>
              {/* <Grid item xs={12} sm={6}><TextField fullWidth label="Admission Fees" name="admission_fees" value={student.admission_fees || ""} onChange={handleChange}   /></Grid> */}


              {/* Fees Structure Section */}
              <Grid item xs={12}>
                <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1976D2", mb: 2 }}>
                  Student Fees Structure
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Paper
                  elevation={4}
                  sx={{
                    padding: 3,
                    borderRadius: 3,
                    backgroundColor: "#FAFAFA",
                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"
                  }}
                >
                  <FormGroup>
                    <Grid container spacing={2}>
                      {/* All Select Checkbox */}
                      <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isAllSelected}
                              onChange={handleAllSelect}
                              sx={{
                                transform: "scale(1.2)",
                                "&.Mui-checked": { color: "#0D47A1" },
                                "&:hover": { backgroundColor: "rgba(13, 71, 161, 0.1)" },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: "600",
                                color: "#0D47A1",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px"
                              }}
                            >
                              All Select
                            </Typography>
                          }
                        />
                      </Grid>

                      {/* Filtered Fees Except Default Checked */}
                      {fees
                        .filter(fee => !defaultCheckedFees.includes(fee.fee_type.toLowerCase()))
                        .map((fee) => (
                          <Grid item xs={12} sm={6} key={fee.id}>
                            <Paper
                              onClick={() => handleFeeChange(fee.id)} // ✅ পুরো বক্সে ক্লিক করলে চেকবক্স টগল হবে
                              sx={{
                                padding: 2,
                                border: "2px solid #0D47A1",
                                borderRadius: "8px",
                                backgroundColor: student.fees.includes(fee.id) ? "#E3F2FD" : "#F5F5F5",
                                transition: "0.3s ease",
                                cursor: "pointer", // ✅ মাউস পয়েন্টার চেঞ্জ হবে
                                "&:hover": { backgroundColor: "#E3F2FD" }
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={student.fees.includes(fee.id)}
                                    onChange={() => handleFeeChange(fee.id)}
                                    onClick={(e) => e.stopPropagation()} // ✅ চেকবক্সে ক্লিক করলে প্যারেন্ট ক্লিক ইভেন্ট ট্রিগার হবে না
                                    sx={{
                                      "&.Mui-checked": { color: "#0D47A1" },
                                      transform: "scale(1.2)"
                                    }}
                                  />
                                }
                                label={
                                  <Typography
                                    variant="body1"
                                    sx={{ fontWeight: "600", color: "#0D47A1", textTransform: "capitalize" }}
                                  >
                                    {fee.fee_type}
                                  </Typography>
                                }
                              />
                            </Paper>
                          </Grid>
                        ))}
                    </Grid>
                  </FormGroup>
                </Paper>
              </Grid>

              {transportLocations.length > 0 && (
                <Grid item xs={12} sm={12}>
                  <Select
                    styles={selectStyles}
                    options={[{ id: "", location_name: "Select Transport Location" }, ...transportLocations]}
                    getOptionLabel={(e) => `${e.location_name}`}
                    getOptionValue={(e) => e.id}
                    onChange={selected => setStudent({ ...student, transportLocations: selected?.id || "" })}
                    placeholder="Select Transport Location"
                    isClearable
                  />
                </Grid>
              )}

              <Grid item xs={12}>

                <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1976D2", mb: 2 }}>
                  Bank Details
                </Typography>

              </Grid>

              <Grid item xs={12} sm={12}>
                <Select
                  styles={selectStyles}
                  options={[{ id: "", name: "Select Bank" }, ...banks]}
                  getOptionLabel={e => e.name}
                  getOptionValue={e => e.id}
                  onChange={selected => setStudent({ ...student, banks: selected?.id || "" })}
                  placeholder="Select Bank "
                  isClearable
                />
              </Grid>

              <Grid item xs={12} sm={6}><TextField fullWidth label="Account Number" name="account_no" value={student.account_no || ""} onChange={handleChange} /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="IFSC Code" name="ifsc_code" onChange={handleChange} onInput={(e) => e.target.value = e.target.value.toUpperCase()} /></Grid>


              {/* Image Upload Section */}

              <Grid item xs={12} sm={12} md={12}>

                <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1976D2", mb: 2 }}>
                  Upload Student Image
                </Typography>

                {/* File Upload Button */}
                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    backgroundColor: "#0288D1",
                    "&:hover": { backgroundColor: "#01579B" },
                    mb: 2,
                  }}
                >
                  Choose Image
                  <input type="file" name="file" accept="image/*" hidden onChange={handleFileChange} />
                </Button>

                {/* Cropper Section */}
                {srcImage && (
                  <Grid item xs={12} sx={{ mt: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                      Crop Image
                    </Typography>
                    <ReactCrop src={srcImage} crop={crop} onChange={setCrop} onComplete={getCroppedImage}>
                      <img ref={imageRef} src={srcImage} alt="Crop Preview" style={{ maxWidth: "100%", borderRadius: 5 }} />
                    </ReactCrop>
                  </Grid>
                )}

                {/* Cropped Image Preview */}
                {croppedImage && (
                  <Grid item xs={12} sx={{ mt: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                      Cropped Image Preview
                    </Typography>
                    <Paper
                      sx={{
                        width: 150,
                        height: 150,
                        borderRadius: "10px",
                        objectFit: "cover",
                        border: "3px solid #0288D1",
                        display: "inline-block",
                        overflow: "hidden",
                      }}
                    >
                      <img src={croppedImage} alt="Cropped" style={{ width: "100%", height: "100%" }} />
                    </Paper>
                  </Grid>
                )}
              </Grid>

            </Grid>

            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 3, py: 1.5, fontSize: 16 }}>
              Add Student
            </Button>
          </form>
        </Paper>
      </Box>
  );
};

export default AddStudent;
